module.exports = __webpack_public_path__ + "img/03.bd898c4b.png";